// extracted by mini-css-extract-plugin
module.exports = {"copyableId":"CopyableID_copyableId__VRGy0","copyableIdTextContainer":"CopyableID_copyableIdTextContainer__k9EON","copyableIdContainer":"CopyableID_copyableIdContainer__L8s0K"};